import React, { useEffect, useState , useRef} from 'react'
import { Button, Input, InputRef, Popconfirm, Space, Table, Tooltip, notification } from 'antd'
import { ColumnType, ColumnsType, TablePaginationConfig } from 'antd/es/table';
import {  deTagSOW, fetchTaggedSowDetails} from '../../store/reducers/orderDashboardSlice';
import { checkAccess, getUserRole, rejectedApiMessage } from '../../utilities/CommonHelper';
import { useDispatch, useSelector } from 'react-redux';
import { getUserAccessData } from '../../utilities/sessionHelper';
import { FilterConfirmProps } from 'antd/es/table/interface';
import {SearchOutlined, InfoCircleTwoTone} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import Link from 'antd/es/typography/Link';




interface DataType {
    key: React.Key;
    sowID: string;
    sowLink: string;
    clientEntity: string;
    sowOwner: string;
    bu: string;
    contractValue: string;
    tagtype: string;
    totalTcv: any;
    contractvalue: any;
    sowstartdate: string;
    sowenddate: string;
    salesspoc: string;
    contracttype: string;
    currency: string;
    sowname: string;
    parentSowid: string;
    parentSowname: string;
    rejectReason: string;
    sowBu: string | null | undefined;
  
  }

  type DataIndex = keyof DataType;
  
 const TaggedSowContainer = (props:any) => {
  const dispatch = useDispatch();
  const orderDashboardData = useSelector((state: any) => state.orderDashboard);
  const [sowDetailsData, setSowDetailsData] = React.useState<any>([]);
  const [pageNo, setPageNo] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const role= getUserRole(getUserAccessData()?.roleAccessMap)||"";

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef<InputRef>(null);
  const writeAccess_order:boolean=checkAccess(role,"Order Dashboard",getUserAccessData()?.roleAccessMap[role],"write");

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex: DataIndex): ColumnType<any> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              setSelectedKeys([]);
              handleSearch([], confirm, dataIndex);
            }}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button> */}
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex] && record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });


  const columns: ColumnsType<DataType> = [
        {
          title: 'SOW ID',
          width: 150,
          dataIndex: 'sowID',
          key: 'sowID',
          fixed: 'left',
          ...getColumnSearchProps('sowID'),
          render: (text: string, record: any, index:number) => {
            return(
              <>
              <a className='maplink' 
               href={record.contractLink} 
               target='_blank'>{text}</a>
               </>
            )
          }
        },
        {
          title: 'Tag',
          dataIndex: 'tagtype',
          key: 'tagtype',
          width: 150,
          ...getColumnSearchProps('tagtype'),

        },
        {
          title: 'Client Entity',
          width: 150,
          dataIndex: 'clientEntity',
          key: 'clientEntity',
          ...getColumnSearchProps('clientEntity'),
        },
        {
            title: 'Parent SOW ID',
            width: 150,
            dataIndex: 'parentSowid',
            key: 'parentSowid',
            ...getColumnSearchProps('parentSowid'),
        },
        {
            title: 'Parent SOW Name',
            width: 150,
            dataIndex: 'parentSowname',
            key: 'parentSowname',
            ...getColumnSearchProps('parentSowname'),
        },
        {
          title: 'Currency',
          dataIndex: 'currency',
          key: 'currency',
          width: 150,
        },
        {
          title: 'Sow Name',
          dataIndex: 'sowname',
          key: 'sowname',
          width: 150,
          ...getColumnSearchProps('sowname'),
        },
        {
          title: ' Total Contract Value (LCY)',
          dataIndex: 'contractvalue',
          key: 'contractvalue',
          width: 150,
          ...getColumnSearchProps('contractvalue'),
          render: (text: string, record: any) => {
            return(
              <>
              <span>{text}</span> &nbsp;
              </>
            )
          }
        },
        {
          title: ' Total Contract Value (USD)',
          dataIndex: 'contractvalueUsd',
          key: 'contractvalueUsd',
          width: 150,
          // ...getColumnSearchProps('contractvalueUsd'),
          render: (text: string, record: any) => {
            return(
              <>
              <span>{text}</span> &nbsp;
              </>
            )
          }
        },
        {
          title: 'Contract Type',
          dataIndex: 'contracttype',
          key: 'contracttype',
          width: 150,
          ...getColumnSearchProps('contracttype'),
        },
        {
          title: 'Business Unit',
          dataIndex: 'sowBu',
          key: 'sowBu',
          width: 150,
          ...getColumnSearchProps('sowBu'),
        },
        {
          title: 'SOW Start Date',
          dataIndex: 'sowstartdate',
          key: 'sowstartdate',
          width: 150,
        },
        {
          title: 'SOW End Date',
          dataIndex: 'sowenddate',
          key: 'sowenddate',
          width: 150,
        },
        {
          title: 'Reject Reason',
          dataIndex: 'rejectReason',
          key: 'rejectReason',
          width: 250,
          ...getColumnSearchProps('rejectReason'),
          render: (text: string, record: any) => {          
            return(
              <>
              <span style={{wordBreak:'break-word'}}>{text}</span> &nbsp;
              </>
            )
          }
        },
        {
          title: 'Sales SPOC',
          dataIndex: 'salesspoc',
          key: 'salesspoc',
          width: 150,
          ...getColumnSearchProps('salesspoc'),
        },
        {
          title: 'Action',
          dataIndex: 'bu',
          key: 'workOrders',
          width: 150,
          fixed: 'right',
          render: (text: string, record: any) => {
            return(
              <>
              <Tooltip title={!writeAccess_order && "Only Accessible by the Role : Finance" }>
                <Popconfirm title="Are you sure to detag this SOW?" onConfirm={()=>handleDetag(record)} okText="Yes" cancelText="No" disabled={!writeAccess_order}>
                  <Link className='maplink' disabled={!writeAccess_order} onClick={()=>null}>DeTag</Link>
              </Popconfirm>
              </Tooltip>
              </>
            )
          }
        }
      ];

      const handleDetag = (record:any) => {
        dispatch(deTagSOW({sowId:record.sowID})).then((res:any)=>{
            if (res.type === 'orderDashboard/deTagSOW/fulfilled') {
                notification.success({
                message: 'Success',
                description: 'SOW Detagged successfully',
                });
                // props.handleRefresh(true);
                fetchTaggedSowDetailsWithPagination();

            } 
            else{
                rejectedApiMessage(res.payload);
            }
        })
      }

    const handleTableChange = (pagination: TablePaginationConfig) => {
        const { current, pageSize } = pagination;
        setPageNo(current ? current - 1 : 0);
        setPageSize(pageSize || 10);
      };
      const fetchTaggedSowDetailsWithPagination = () => {
        dispatch(fetchTaggedSowDetails()).then((res: any) => {
              
          if (res.type !== 'orderDashboard/fetchTaggedSowDetails/fulfilled') {
            rejectedApiMessage(res.payload);
          }else{
            setSowDetailsData(res.payload);
            setTotalCount(res.payload);
            setPageNo(0);
        } 
        });
      }

      const handleTableRefresh = (refreshTable:boolean) => {
        if(refreshTable){
            fetchTaggedSowDetailsWithPagination();
        }
      }

      useEffect(() => {
        if(props.activeTab==='4'){
          props.showWorkOrderTab({},false);
          fetchTaggedSowDetailsWithPagination();
        }
      },[orderDashboardData.isSOWDataUpdated,props.activeTab]); 

    
  return (
    <>
    <div className='containerr'>
      <div className='row'>
        <h2 className='col-lg-6 col-sm-12 page-heading'>
          Tagged SOW DASHBOARD
        </h2>
      </div>

      <Table 
      className='table-style'
      columns={columns} 
      dataSource={sowDetailsData} 
    //   loading={orderDashboardData.isLoading}
      scroll={{ x: 'max-content', y: 350}}
        pagination={{
          current: pageNo + 1,
          pageSize,
          total: totalCount,
        showSizeChanger: false,
        }}
        onChange={handleTableChange} />
    </div>

    </>
  )
}
export default TaggedSowContainer;